import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { normalize, schema } from 'normalizr'

const normalizeContributions = data => {
  const contribution = new schema.Entity('contributions')
  return normalize(data, [contribution])
}

const DiscussionReducer = combineReducers({
  fetchDiscussionRequest: createRequestReducer('DISCUSSION:FETCH'),
  submitContributionRequest: createRequestReducer('DISCUSSION:SUBMIT'),
  inviteContributorRequest: createRequestReducer(
    'ASSESSMENT_FILE_STORE:INVITE'
  ),
  contributions: createReducer(null, {
    'DISCUSSION:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeContributions(response.data.assessment_file.actions),
    'DISCUSSION:SUBMIT_REQUEST_SUCCESS': (state, { response, params }) => {
      const actions = normalizeContributions(response.data.actions)
      const stateWithAddedContributions = {
        ...state,
        result: [...actions.result, ...state.result],
        entities: {
          contributions: {
            ...actions.entities.contributions,
            ...state.entities.contributions
          }
        }
      }
      if (params.currentConclusion) {
        return {
          ...stateWithAddedContributions,
          entities: {
            contributions: {
              ...stateWithAddedContributions.entities.contributions,
              [params.currentConclusion]: {
                ...stateWithAddedContributions.entities.contributions[
                  params.currentConclusion
                ],
                action_object: {
                  ...stateWithAddedContributions.entities.contributions[
                    params.currentConclusion
                  ].action_object,
                  conclusion: false
                }
              }
            }
          }
        }
      } else {
        return stateWithAddedContributions
      }
    },
    'DISCUSSION:SUBMIT_REPLY_REQUEST_SUCCESS': (
      state,
      { response, params }
    ) => {
      const addedAction = {
        actions: response.data.actions,
        id: response.data.actions[0].action_object.id
      }
      let replies =
        state.entities.contributions[params.id].action_object.replies
      replies.push(addedAction)
      return {
        ...state,
        entities: {
          contributions: {
            ...state.entities.contributions,
            [params.id]: {
              ...state.entities.contributions[params.id],
              action_object: {
                ...state.entities.contributions[params.id].action_object,
                replies: replies
              }
            }
          }
        }
      }
    },
    'DISCUSSION:DELETE_REQUEST_SUCCESS': (state, { params }) => {
      const contributions = { ...state.entities.contributions }
      delete contributions[params.actionId]
      return {
        entities: { contributions },
        result: state.result.filter(id => id !== params.actionId)
      }
    },
    'DISCUSSION:EDIT_REQUEST_SUCCESS': (state, { response, params }) => {
      return {
        ...state,
        entities: {
          contributions: {
            ...state.entities.contributions,
            [params.actionId]: {
              ...state.entities.contributions[params.actionId],
              action_object: {
                ...state.entities.contributions[params.actionId].action_object,
                content: params.body.content,
                edited_at: true
              }
            }
          }
        }
      }
    },
    'DISCUSSION:DELETE_REPLY_REQUEST_SUCCESS': (
      state,
      { response, params }
    ) => {
      const replies =
        state.entities.contributions[params.parentId].action_object.replies
      replies.forEach((reply, index) => {
        if (reply.id === params.contributionId) {
          replies.splice(index, 1)
        }
      })
      return {
        ...state,
        entities: {
          contributions: {
            ...state.entities.contributions,
            [params.parentId]: {
              ...state.entities.contributions[params.parentId],
              action_object: {
                ...state.entities.contributions[params.parentId].action_object,
                replies: replies
              }
            }
          }
        }
      }
    },
    'DISCUSSION:EDIT_REPLY_REQUEST_SUCCESS': (state, { response, params }) => {
      const replies =
        state.entities.contributions[params.parentId].action_object.replies
      replies.forEach((reply, index) => {
        if (reply.id === params.contributionId) {
          replies[index] = {
            ...state.entities.contributions[params.parentId].action_object
              .replies[index],
            actions: [
              {
                action_object: {
                  ...state.entities.contributions[params.parentId].action_object
                    .replies[index].actions[0].action_object,
                  content: params.body.content,
                  edited_at: true
                }
              }
            ]
          }
        }
      })
      return {
        ...state,
        entities: {
          contributions: {
            ...state.entities.contributions,
            [params.parentId]: {
              ...state.entities.contributions[params.parentId],
              action_object: {
                ...state.entities.contributions[params.parentId].action_object,
                replies: replies
              }
            }
          }
        }
      }
    },
    'ASSESSMENT_FILE_STORE:INVITE_REQUEST_SUCCESS': (state, { response }) => {
      const actions = normalizeContributions(response.data.actions)
      return {
        ...state,
        result: [...state.result, ...actions.result],
        entities: {
          contributions: {
            ...state.entities.contributions,
            ...actions.entities.contributions
          }
        }
      }
    },
    'DISCUSSION:MARK_AS_CONCLUSION_REQUEST_SUCCESS': (
      state,
      { params, response }
    ) => {
      const last = response.data.actions.length - 1
      return {
        ...state,
        result: [...state.result, response.data.actions[last].id],
        entities: {
          contributions: {
            ...state.entities.contributions,
            [params.actionId]: {
              ...state.entities.contributions[params.actionId],
              action_object: {
                ...state.entities.contributions[params.actionId].action_object,
                conclusion: true,
                marked_as_conclusion_by:
                  response.data.actions[last].action_object
                    .marked_as_conclusion_by
              }
            },
            [response.data.actions[last].id]: response.data.actions[last]
          }
        }
      }
    },
    'DISCUSSION:UNMARK_AS_CONCLUSION_REQUEST_SUCCESS': (
      state,
      { params, response }
    ) => {
      const last = response.data.actions.length - 1
      return {
        ...state,
        result: [...state.result, response.data.actions[last].id],
        entities: {
          contributions: {
            ...state.entities.contributions,
            [params.actionId]: {
              ...state.entities.contributions[params.actionId],
              action_object: {
                ...state.entities.contributions[params.actionId].action_object,
                conclusion: false
              }
            },
            [response.data.actions[last].id]: response.data.actions[last]
          }
        }
      }
    }
  }),
  sidebar: createReducer(
    { opened: true },
    {
      'DISCUSSION:SIDEBAR:OPEN': state => ({
        ...state,
        opened: true
      }),
      'DISCUSSION:SIDEBAR:CLOSE': state => ({
        ...state,
        opened: false
      })
    }
  ),
  templates: createReducer(
    { visible: false },
    {
      'DISCUSSION:TEMPLATES:SHOW': state => ({
        ...state,
        visible: true
      }),
      'DISCUSSION:TEMPLATES:HIDE': state => ({
        ...state,
        visible: false
      })
    }
  ),
  works: createReducer(
    { visible: false },
    {
      'DISCUSSION:WORKS:SHOW': state => ({
        ...state,
        visible: true
      }),
      'DISCUSSION:WORKS:HIDE': state => ({
        ...state,
        visible: false
      })
    }
  ),
  editContributionDialog: createReducer(
    { opened: false },
    {
      'DISCUSSION:EDIT_CONTRIBUTION_DIALOG:OPEN': (state, { params }) => ({
        ...state,
        opened: true,
        id: params.id,
        contributionId: params.contributionId,
        body: params.body,
        parentId: params.parentId
      }),
      'DISCUSSION:EDIT_CONTRIBUTION_DIALOG:CLOSE': state => ({
        ...state,
        opened: false
      })
    }
  )
})

export default DiscussionReducer
